import {MessageCodes} from "../MessageCodes";
import ResultText from "../ResultText";
import ComparisonCSName from "../../ComparisonCSName";
import ToUpper from "../ToUpper";
import numWords from "num-words";
import {useUser} from "../../../Context/UserContext";
import ResultView from "../../V2/ResultView";

export function C15({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

const renderItem = ({name, base, compare}) => {
    if((!base && !compare) || (base === '*' && compare === '*'))
        return name
    else if(base && !compare)
        return `${name} (${base}/None)`
    else if(!base && compare)
        return `${name} (None/${compare})`

    return `${name} (${base}/${compare})`
}

const Description = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Compare.ISSTR01.error_id: {
            return (
                <>
                    <ResultText>
                        {ToUpper(numWords(row?.data?.length))} ({row?.data?.length}) inline structures at the following river stations are added
                    </ResultText>
                    <ResultText>
                        <ComparisonCSName csNameList={row.data.map(x => x.cross_section)} />
                    </ResultText>
                </>
            )
        }
        case MessageCodes.Compare.ISSTR02.error_id: {
            return (
                <>
                    <ResultText>
                        {ToUpper(numWords(row?.data?.length))} ({row?.data?.length}) inline structures at the following river stations are removed
                    </ResultText>
                    <ResultText>
                        <ComparisonCSName csNameList={row.data.map(x => x.cross_section)} />
                    </ResultText>
                </>
            )
        }

        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}